const prefix = "shared-header__";

/**
 * Central store for classNames
 */
export default {
  layout: {
    logo: `${prefix}logo`,
    menuButtonMobile: `${prefix}btn-mobile--menu`,
    navContainer: `${prefix}nav`,
    navContainerWrapper: `${prefix}nav-wrapper`,
    rootElement: "shared-header",
    topBar: `${prefix}top-bar`,
  },
  modifiers: {
    active: "is-active",
    hidden: "is-hidden",
    submenu: "submenu-is-open",
  },
  navDomain: {
    nav: `${prefix}nav-domain`,
  },
  navPrimary: {
    container: `${prefix}nav__list`,
    listItem: `${prefix}nav__item`,
    mainItem: `${prefix}nav__link`,
    subNav: `${prefix}nav__sub-nav`,
    subNavGroup: `${prefix}nav__sub-nav__group-wrapper`,
  },
  overlay: `${prefix}overlay`,
  search: {
    dialog: `${prefix}search-dialog`,
    autoComplete: `${prefix}search-auto-complete`,
    buttonClear: `${prefix}search-btn-clear`,
    buttonSubmit: `${prefix}search-btn-submit`,
    buttonToggleSearchMobile: `${prefix}btn-mobile--search`,
    form: `${prefix}search`,
    formWrapperMobile: `${prefix}search-wrapper`,
    list: `${prefix}list`,
    listLabel: `${prefix}list-label`,
  },
};
